import { render, staticRenderFns } from "./OrchardPublish.vue?vue&type=template&id=9282288c&scoped=true"
import script from "./OrchardPublish.vue?vue&type=script&lang=js"
export * from "./OrchardPublish.vue?vue&type=script&lang=js"
import style0 from "./OrchardPublish.vue?vue&type=style&index=0&id=9282288c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9282288c",
  null
  
)

export default component.exports